module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h2>Documents  <span id="count" class="text-muted"></span></h2>\n\n<div id="documents"></div>\n<div id="pager"></div>\n\n<div id="assign-reviewers-form"></div>\n<div id="add-patient-form-modal"></div>\n<div id="set-due-form-modal"></div>\n<div id="add-comment-form-modal"></div>\n<div id="send-form-modal"></div>\n<div id="add-addendum-form-modal"></div>\n<div id="mark-as-modal"></div>\n<div id="export-modal"></div>\n<div class="password-confirmation-div"></div>\n<div id="add-patient-warning"></div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/documents/documents.html
// module id = 334
// module chunks = 0